import { Component, OnInit } from '@angular/core';
import { IUITKSelectItemProps } from '@uitk/angular/forms/select/select-item.interface';
import { Subscription } from 'rxjs';
import { Mode } from '../../enums/mode.enum';
import { SearchInvoiceByCCSearchDto } from '../../dtos/searchinvoice-by-cc-search-dto.model';
import { ConfigService } from '../../services/config.service';
import { ModeService } from '../../services/mode.service';
import { SearchInvoiceByCCService } from '../../services/search-invoice-bycc.service';

@Component({
  selector: 'app-searchinvoice-by-cc',
  templateUrl: './searchinvoice-by-cc.component.html',
  styleUrls: ['./searchinvoice-by-cc.component.css']
})

export class SearchinvoiceByCCComponent implements OnInit {
  configIsReadySubscription: Subscription | undefined;
  collapsiblePanel = true;
  openPanel = true;
  panelBackgroundOpen = "uitk-l-grid-open";
  panelBackground = this.panelBackgroundOpen;
  defaultLabel = "- Please\u00A0Select";
  showResults=false;
  showTokenError=false;
  showccLast4Error=false;
  payMethodList: IUITKSelectItemProps[] = [];
  ccPayMethodList: IUITKSelectItemProps[] = [];
  payMethod: IUITKSelectItemProps | null=null ;
  ccLast4='';
  token = '';
  Mode= Mode;
  isDeclined = false;

  constructor(public configService: ConfigService,public modeService: ModeService,
    public searchInvoiceByCCService: SearchInvoiceByCCService) { }

  ngOnInit(): void {
    this.ccPayMethodList = this.configService.getPickList("CCPMETH");
    this.payMethodList = this.ccPayMethodList;

    const searchFiltersRaw = localStorage.getItem('searchOperator');
    let searchFilters: any = null;
    if (searchFiltersRaw) {
      try {
        searchFilters = JSON.parse(searchFiltersRaw);
      } catch (e) {
        searchFilters = null;
      }
    }
    if (searchFilters && Array.isArray(searchFilters.filters)) {
      this.payMethod = this.payMethodList.filter(c => c.value === this.getFiltersSearchValue(searchFilters.filters, 'payMethod'))[0] || null;
    }
  }

  getFiltersSearchValue(filters: any, searchField: string) {
    if (filters.findIndex((f: { searchField: string; }) => f.searchField === searchField) > -1) {
      return filters.filter((f: { searchField: string; }) => f.searchField === searchField)[0].searchValue;
    }
    else {
      return '';
    }
  }

  setPanelBGHeight() {
    if (this.panelBackground === this.panelBackgroundOpen) {
      this.panelBackground = "uitk-l-grid1-close";
    }
    else {
      this.panelBackground = this.panelBackgroundOpen;
    }
  }

  OnChangeCCLast4()
  {
    this.showccLast4Error = false;
    if (this.ccLast4 || this.token) {
      this.showccLast4Error = false;
    }
  }
  OnChangeToken()
  {
    this.showTokenError = false;
    if (this.ccLast4 || this.token) {
      this.showTokenError = false;
    }
  }

  OnSearchClick() {
    if(this.ccLast4==='' && this.token==='')
    {
      this.showccLast4Error = true;
      this.showTokenError = true;
    }
    else
    {
      this.showResults=false
      this.modeService.mode = Mode.InvoiceByCCWait;
      let searchOperator = new SearchInvoiceByCCSearchDto();
      searchOperator.CCType=this.payMethod?.value==null ? "":this.payMethod?.label;
      searchOperator.ccLast4 = this.ccLast4.trim();
      searchOperator.isDeclined = this.isDeclined;
      searchOperator.ccToken = this.token.trim();
      this.searchInvoiceByCCService.Invoices = null;
      this.searchInvoiceByCCService.searchInvoices(Mode.View, searchOperator);
      this.showResults=true
    }
  }
  clearInput()
  {
    this.isDeclined=false;
    this.ccLast4='';
    this.token = '';
    this.payMethod=null;
    this.showResults=false;
  }
}
